import { ArrowLeftRight, Phone, PhoneIncoming, PhoneOutgoing } from 'lucide-react';

/* Which way the call went — not how it ended.

   A missed call is still an inbound call, so the outcome lives in the status
   pill and this stays purely directional. The red/mint here is brand and
   direction, not status. */
export default function DirIcon({ dir }) {
  switch (dir) {
    case 'in':
      return <PhoneIncoming size={16} color="var(--mint)" aria-label="Inbound" />;
    case 'out':
      return <PhoneOutgoing size={16} color="var(--signal)" aria-label="Outbound" />;
    case 'internal':
      return <ArrowLeftRight size={16} color="var(--ink-soft)" aria-label="Internal" />;
    default:
      return <Phone size={16} color="var(--ink-soft)" aria-label="Call" />;
  }
}
